import React, { useState } from "react";
import Modal from "../../app/UI/Modal/Modal";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { closeModal } from "./modalActions";
import { reverseTransaction } from "../transactions/transactionsActions";
import { ReactComponent as Spinner } from "../../assets/spinner.svg";
import { moneyFormat } from "../../app/common/util/moneyFormat";

const ReversalConfirmationModal = ({
  closeModal,
  transaction,
  reversalAmount,
  reversalReason,
  originalAmount,
  reverseTransaction,
}) => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Guard: prevent render if transaction not available
  if (!transaction || !transaction.transactionType) {
    return null;
  }

  const handleConfirm = async () => {
    setIsSubmitting(true);

    try {
      const reversalTransaction = {
        ...transaction,
        reversalReason: reversalReason,
        transactionAmount: reversalAmount,
      };

      await reverseTransaction(reversalTransaction);
      closeModal();
    } catch (err) {
      toastr.error("Oops", "Failed to reverse transaction. Please try again.");
      console.error("Reversal error:", err);
      setIsSubmitting(false);
    }
  };

  return (
    <Modal modalHeader="Confirm Transaction Reversal" onClose={closeModal}>
      <div>
        <p>Are you sure you want to reverse this transaction?</p>
        <p>
          <strong>Transaction Type:</strong> {transaction.transactionType}
        </p>
        <p>
          <strong>Original Amount:</strong> {moneyFormat(originalAmount)}
        </p>
        <p>
          <strong>Reversal Amount:</strong> {moneyFormat(reversalAmount)}
        </p>
        <p>
          <strong>Reversal Reason:</strong> {reversalReason}
        </p>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          marginTop: "20px",
        }}
      >
        <button
          onClick={closeModal}
          style={{ marginRight: "10px", padding: "10px 20px" }}
          disabled={isSubmitting}
        >
          Cancel
        </button>
        <button
          onClick={handleConfirm}
          style={{
            padding: "10px 20px",
            backgroundColor: isSubmitting ? "#cccccc" : "#007bff",
            color: "white",
            border: "none",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          disabled={isSubmitting}
        >
          {isSubmitting ? (
            <>
              <Spinner
                style={{
                  width: "20px",
                  height: "20px",
                  marginRight: "10px",
                }}
              />
              Reversing...
            </>
          ) : (
            "Confirm Reversal"
          )}
        </button>
      </div>
    </Modal>
  );
};

const mapStateToProps = (state) => {
  const modalProps = (state.modals && state.modals.modalProps) || {};
  return {
    transaction: modalProps.transaction || {},
    reversalAmount: modalProps.reversalAmount,
    reversalReason: modalProps.reversalReason,
    originalAmount: modalProps.originalAmount,
  };
};

const actions = {
  reverseTransaction,
  closeModal,
};

export default connect(mapStateToProps, actions)(ReversalConfirmationModal);
